export default __webpack_public_path__ + "scripts/resources/assignments/en/iron_thiocyanate/configuration.json";